module.exports = __webpack_public_path__ + "img/bdhyq-lx.ebc27203.jpg";